<template>
    <div class="help-center-content">
        <h4>成为主播</h4>
        <p class="title">1.  如何成为主播？</p>
        <p class="content">要成为主播，按照要求完善资料，并至少上传3条声音，就能轻松完成认证喔。<a :href="`${$store.state.ANCHOR_AUTH_URL}`" target="_blank">去认证</a></p>
        <p class="title">2.  成为主播以后有什么权益呢？</p>
        <p class="content">认证成为主播之后，您能在作品有声化平台内享有以下权益：
            <br><strong>赚取收益</strong>：寻找并参与海选任务，录制完作品后，您能获取录制佣金、作品分成或广告收益；
            <br><strong>管理任务</strong>：在主播工作台里，轻松管理参选任务和播讲作品；
            <br><strong>数据服务</strong>：新增粉丝，收听数据，听众分析，一目了然，尽在掌控之中；
            <br><strong>Podcast服务</strong>：免费的苹果iTunes播客服务，有机会被数亿用户发现；
        </p>
        <p class="title">3. 申请时需要提交哪些资料呢？</p>
        <p class="content">个人认证需要提供真实身份证明。
            <br>机构认证需要提供证明机构身份的真实材料，或运营者身份证明。
            <br>需要微博V认证，或在其他平台有一定粉丝量的名人或企业，可以通过名人名企绿色通道，我们将由专人为您服务。</p>
        <p class="title">4. 审核时间需要多久？</p>
        <p class="content">审核的周期在3个工作日左右。</p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {
      }
    },
    computed: {
      IMG_HOST() {
        return this.$store.state.IMG_HOST;
      }
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// BeAnAnchor.vue?6132af3f